import { AdministrationRole, GuaranteesApprovalStatus } from './taskModels.ts';
import type { TTaskInternalApprovalType, TTaskRoleKey } from './types.ts';

export const internalApprovalRoleToType = {
  [AdministrationRole.UBTF_ADMINISTRATOR]: 'udbtf',
  [AdministrationRole.UBTF_CONTROLLER]: 'udbtf',
  [AdministrationRole.UO_ADMINISTRATOR]: 'uo',
  [AdministrationRole.UO_CONTROLLER]: 'uo',
  [AdministrationRole.UMVN_ADMINISTRATOR]: 'umvn',
  [AdministrationRole.UMVN_CONTROLLER]: 'umvn',
} as const;

export type TInternalApprovalRole = keyof typeof internalApprovalRoleToType;

export const internalApprovalTypeLabels: Record<TTaskInternalApprovalType, string> = {
  udbtf: 'УДБТФ',
  uo: 'ЮО',
  umvn: 'УМВН',
};

export const internalApprovalStatusLabels: Record<string, string> = {
  [GuaranteesApprovalStatus.PENDING]: 'Очікує погодження',
  [GuaranteesApprovalStatus.IN_PROGRESS]: 'В роботі',
  [GuaranteesApprovalStatus.APPROVED]: 'Погоджено',
  [GuaranteesApprovalStatus.SKIPPED]: 'Пропущено',
  [GuaranteesApprovalStatus.DENIED]: 'Відхилено',
};

export const internalApprovalRolePriority = [
  AdministrationRole.UBTF_ADMINISTRATOR,
  AdministrationRole.UBTF_CONTROLLER,
  AdministrationRole.UO_ADMINISTRATOR,
  AdministrationRole.UO_CONTROLLER,
  AdministrationRole.UMVN_ADMINISTRATOR,
  AdministrationRole.UMVN_CONTROLLER,
] as const satisfies readonly TInternalApprovalRole[];

export const internalApprovalRoles: readonly TTaskRoleKey[] = internalApprovalRolePriority;
